import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getUserList } from '../../../api/users'
import { useCan } from 'src/hooks/useCan';
import { SLUGS } from 'src/enum/permissions.enum';
import { Chip } from '@mui/material';

export default function Users(props) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='user'
        title='Список пользователей'
        columns={[
          { id: 'surname', name: 'Фамилия', },
          { id: 'name', name: 'Имя', },
          { id: 'patronymic', name: 'Отчество', },
          {
            id: 'roles', name: 'Статус', type: 'component',
            component: ({ obj }) => <>
              {obj.roles.map(e=><Chip key={e.id} label={e.name} variant="outlined" size="small"/>)}
            </>
          }
        ]}
        createItem={can(SLUGS.USER.CREATE)}
        loadAPI={{
          request: getUserList,
        }}
        click={can(SLUGS.USER.CREATE)}
        classes={{}}
        {...props}
      />
    </div>
  )
};